module.exports = __webpack_public_path__ + "img/slim_cleanstation30.efc76ea5.jpg";